import { NEARBY } from '@habity/constants';
import { NestedHome } from '@habity/types';
import { TableDataItem } from '~/components/ui/tables/Table';
import { getNearbyButtonIcon } from '~/constants';

export const getNearbyDescription = (home: NestedHome) => {
  const { nearby_json } = home || {};
  
  if (!nearby_json || nearby_json.length === 0) {
    return 'På gångavstånd';
  }

  // Get valid nearby types from constants
  const validTypes = new Set(NEARBY.map(n => n.key));
  const validItems = nearby_json.filter(item => 
    item.type && validTypes.has(item.type) && item.name
  );

  if (validItems.length === 0) {
    return 'På gångavstånd';
  }

  if (validItems.length > 3) {
    return `${validItems.length} tjänster på gångavstånd`;
  }

  // Sort by distance and get closest
  const sorted = [...validItems].sort((a, b) => a.distance - b.distance);
  const nearbyType = NEARBY.find(n => n.key === sorted[0].type);
  
  if (nearbyType) {
    return `${nearbyType.title} på gångavstånd`;
  }
  
  return 'På gångavstånd';
};

export const getNearbyData = (home: NestedHome) => {
  const { nearby_json } = home || {};
  
  if (!nearby_json || nearby_json.length === 0) {
    return [];
  }

  // Get valid nearby types from constants
  const validTypes = new Set(NEARBY.map(n => n.key));
  const validItems = nearby_json.filter(item => 
    item.type && validTypes.has(item.type) && item.name
  );

  // Get unique types present in the data
  const presentTypes = new Set(validItems.map(item => item.type));
  
  // Return NEARBY items that have data
  return NEARBY.filter(nearby => presentTypes.has(nearby.key));
};

export const getNearbyDataForBuyer = (nearby?: string[] | null) => {
  const data: TableDataItem[] = [];

  NEARBY.filter((f) => nearby?.includes(f.key)).map((b) =>
    data.push({
      icon: getNearbyButtonIcon(b.key),
      label: b.title,
      value: '',
      id: b.key,
    })
  );

  return data;
};
